export class DivisionTblDto {
  id: string;
  DivisionName: string;
  DivisionCode: string;
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;
}
